import { Box } from '@mui/material';

// ==============================|| HEADER CONTENT - MESSAGES ||============================== //

const Message = () => {
  return <Box sx={{ flexShrink: 0, ml: 0.75 }}></Box>;
};

export default Message;
